module.exports = __webpack_public_path__ + "img/logoapartvolledig.4c3deddf.png";